<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2022-07-03 00:42:29
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2022-07-22 15:06:33
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\termPage\interaction\components\reportedRecord\index.vue
-->
<!-- 用户评价 -->
<template>
    <div class='reportedRecord' v-loading="loading">
        <!-- 筛选 -->
        <div class="serach">
            <div class="left">
                <el-select v-model="selectChange" size='small' style="width: 166px;margin-right:20px"
                    @change="selectChangeFunction">
                    <el-option label="状态" :value="5"></el-option>
                    <el-option label="真实姓名" :value="1"></el-option>
                    <el-option label="评价时间筛选" :value="2"></el-option>
                    <el-option label="对应医生" :value="3"></el-option>
                    <el-option label="用户名" :value="4"></el-option>
                    <el-option label="审核状态" :value="6"></el-option>
                    <el-option label="评价星级" :value="7"></el-option>
                </el-select>
                <el-input v-if="selectChange != 2 && selectChange != 5 && selectChange != 6 && selectChange != 7"
                    :placeholder="selectChange == 1 ? '请输入真实姓名' : selectChange == 3 ? '请输入对应医生' : selectChange == 4 ? '请输入用户名' : selectChange == 7 ? '请输入评价星级' : ''"
                    style="width: 166px;margin-right:20px" size='small' v-model="inputvalue">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <el-select v-if="selectChange == 5" v-model="searchForm.seq" size='small'
                    style="width: 166px;margin-right:20px">
                    <el-option label="已置顶" :value="1"></el-option>
                    <el-option label="未置顶" :value="0"></el-option>
                </el-select>
                <el-select v-if="selectChange == 7" v-model="searchForm.commentStars" size='small'
                    style="width: 166px;margin-right:20px">
                    <el-option label="1" :value="1"></el-option>
                    <el-option label="2" :value="2"></el-option>
                    <el-option label="3" :value="3"></el-option>
                    <el-option label="4" :value="4"></el-option>
                    <el-option label="5" :value="5"></el-option>
                </el-select>
                <el-select v-if="selectChange == 6" v-model="statusSelect" size='small'
                    style="width: 166px;margin-right:20px" @change="statusChange">
                    <el-option label="待审核" value="init"></el-option>
                    <el-option label="显示内容" value="show"></el-option>
                    <el-option label="隐藏内容" value="hidden"></el-option>
                </el-select>
                <el-date-picker v-if="selectChange == 2" style="margin-right: 20px;" size="small"
                    value-format="yyyy-MM-dd" v-model="times" :default-time="['00:00:00']" clearable align="center"
                    popper-class="popper-class" type="daterange" range-separator="至" start-placeholder="开始日期"
                    end-placeholder="结束日期" @change="timeChange">
                </el-date-picker>
                <el-button type="primary" size='small' @click="getList()">搜索</el-button>
                <el-button size='small' @click="resectData()">重置</el-button>
            </div>
            <div class="right">
                <el-button type="primary" size='small' @click="toStatistics()">数据统计</el-button>
            </div>
        </div>
        <!-- 表格 -->
        <div class="table-container">
            <el-table id="tableInfo" :data="tableData" style="width: 100%">
                <el-table-column prop="id" label="ID" align="center"></el-table-column>
                <el-table-column prop="patientUsername" label="用户名" align="center" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="patientRealName" label="真实姓名" align="center" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="stars" width="250px" label="评价星级" align="center">
                    <template slot-scope="scope">
                        <el-rate v-model="scope.row.commentStars" disabled :show-text="false" :show-score="true"
                            text-color="#ff9900" score-template="{value}">
                        </el-rate>
                    </template>
                </el-table-column>
                <el-table-column prop="content" label="评价内容" align="center" width="100px" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="refName" label="对应医生" align="center"></el-table-column>
                <el-table-column prop="diseaseName" label="对应病种" align="center"></el-table-column>
                <el-table-column prop="createTime" label="评价时间" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="updateUserName" label="操作人" align="center"></el-table-column>
                <el-table-column prop="status" label="审核状态" align="center">
                    <template slot-scope="scope">{{ scope.row.status == 'init' ? '待审核' : scope.row.status == 'done' ?
                            scope.row.visibility == 'hidden' ? '隐藏内容' : '显示内容' : '--'
                    }}</template>
                </el-table-column>
                <el-table-column prop="seq" label="状态" align="center">
                    <template slot-scope="scope">{{ scope.row.seq == 1 ? '已置顶' : '--' }}</template>
                </el-table-column>
                <el-table-column label="操作" width="200px" align="center" fixed="right">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 'init'">  
                            <el-popconfirm
                                icon="none"
                                @confirm="toExamine(scope.row, scope.$index, 2)"
                                @cancel="toExamine(scope.row, scope.$index, 1)"
                                cancel-button-type="defalut"
                                confirm-button-text="审核通过"
                                cancel-button-text="隐藏内容"
                                >
                                <el-button slot="reference" size="mini" style="padding-right: 10px;" type="text">审核</el-button>
                            </el-popconfirm>
                        </span>
                            
                        <el-button type="text" size="mini" slot="reference"
                            @click="viewDetail(scope.row, scope.$index)">查看</el-button>
                        <el-button v-if="scope.row.status == 'done' && scope.row.seq == 0" type="text" size="mini"
                            slot="reference" @click="onTop(scope.row, scope.$index)">置顶</el-button>
                        <el-button v-if="scope.row.status == 'done' && scope.row.seq == 1" type="text" size="mini"
                            slot="reference" @click="onTop(scope.row, scope.$index)">取消置顶</el-button>
                        <el-button v-if="scope.row.visibility == 'hidden' && scope.row.status == 'done'" type="text"
                            size="mini" slot="reference" @click="hideDetail(scope.row, scope.$index, 2)">显示内容
                        </el-button>
                        <el-button v-if="scope.row.visibility == 'show' && scope.row.status == 'done'" type="text"
                            size="mini" slot="reference" @click="hideDetail(scope.row, scope.$index, 1)">隐藏内容
                        </el-button>

                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page.sync="searchForm.current" :page-size="searchForm.size"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
        <!-- 查看详情弹窗 -->
        <el-dialog title="查看详情" :visible.sync="viewDetailDialog" v-if="viewDetailDialog" width="30%" v-loading="loading"
            :close-on-click-modal='false'>
            <div class="detail-dialog">
                <el-scrollbar style="height: 100%;font-size: 12px;width:100%">
                    <el-form :model="detailForm" ref="ruleForm" label-width="140px" class="demo-ruleForm">
                        <el-form-item label="评价ID：" prop="name">
                            <div class="right-content">{{ detailForm.id }}</div>
                        </el-form-item>
                        <el-form-item label="用户名：" prop="region">
                            <div class="right-content">{{ detailForm.patientUsername }}</div>
                        </el-form-item>
                        <el-form-item label="真实姓名：" prop="region">
                            <div class="right-content">{{ detailForm.patientRealName }}</div>
                        </el-form-item>
                        <el-form-item label="评价星级：" prop="region">
                            <el-rate style="line-height: 3;" v-model="detailForm.commentStars" disabled
                                :show-text="false" :show-score="true" text-color="#ff9900" score-template="{value}">
                            </el-rate>
                        </el-form-item>
                        <el-form-item label="评价内容：" prop="region">
                            <div class="right-content">{{ detailForm.content }}</div>
                        </el-form-item>
                        <el-form-item label="对应医生：" prop="region">
                            <div class="right-content">{{ detailForm.refName }}</div>
                        </el-form-item>
                        <el-form-item label="对应病种：" prop="region">
                            <div class="right-content">{{ detailForm.diseaseName }}</div>
                        </el-form-item>
                        <el-form-item label="评价时间：" prop="region">
                            <div class="right-content">{{ detailForm.createTime }}</div>
                        </el-form-item>
                        <el-form-item label="操作人：" prop="region">
                            <div class="right-content">{{ detailForm.updateUserName }}</div>
                        </el-form-item>
                        <el-form-item label="审核状态：" prop="region">
                            <div class="right-content">{{ detailForm.status == 'init' ? '待审核' : detailForm.status
                                    == 'done' ? detailForm.visibility == 'hidden' ? '隐藏内容' : '显示内容' : '--'
                            }}</div>
                        </el-form-item>
                        <el-form-item label="状态：" prop="region">
                            <div class="right-content">{{ detailForm.seq == 1 ? '已置顶' : '--' }}</div>
                        </el-form-item>
                    </el-form>
                </el-scrollbar>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getCommentPage, setAdopt, setTop, setHidden } from '../../api/index.js'
export default {
    data() {
        //这⾥存放数据
        return {
            statusSelect: null,
            loading: true,
            changePlaceholder: "请输入真实姓名",
            selectChange: 5,
            inputvalue: '',
            searchForm: {
                current: 1,//页数
                size: 10,//每页多少条
                startTime: null,
                visibility: null,//状态 show   hidden
                endTime: null,
                status: null,//审核状态
                patientRealName: null,//真实姓名
                doctorName: null,//对应医生
                patientUsername: null,//用户名
                commentStars: null,//评价星级,
                seq: null,
            },
            total: 0,//每页10条
            tableData: [
                {}
            ],
            value: 5,
            viewDetailDialog: false,//查看详情弹窗
            detailForm: {},
            times: [],
        };
    },
    //监听属性类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //⽅法集合
    methods: {
        //重置筛选数据
        resectData() {
            this.selectChange = 5
            this.searchForm.visibility = null;
            this.searchForm.current = 1;
            this.searchForm.size = 10;
            this.searchForm.startTime = null;
            this.searchForm.endTime = null;
            this.searchForm.status = null;
            this.searchForm.patientRealName = null;
            this.searchForm.doctorName = null;
            this.searchForm.patientUsername = null;
            this.searchForm.commentStars = null;
            this.searchForm.seq = null;
            this.inputvalue = null;
            this.getList();
        },
        //获取列表数据
        getList() {
            this.loading = true
            if (this.selectChange == 1) {
                this.searchForm.patientRealName = this.inputvalue;
            } else if (this.selectChange == 3) {
                this.searchForm.doctorName = this.inputvalue;
            } else if (this.selectChange == 4) {
                this.searchForm.patientUsername = this.inputvalue;
            }
            getCommentPage(this.searchForm).then(res => {
                this.tableData = res.data.records;
                this.tableData.forEach(item=>{
                    item.visible = false;
                })
                this.total = res.data.total;
                this.loading = false
                setTimeout(() => {
                    this.$emit('upDateNumber');
                }, 1000)
            })
        },
        //查看详情
        viewDetail(row, index) {
            this.viewDetailDialog = true;
            this.detailForm = row;
        },
        //跳转数据统计
        toStatistics() {
            this.$router.push('/termPage/statistics')
        },
        //选择
        handleChange(value) {
        },
        //分页
        handleSizeChange(event) {
            this.searchForm.size = event;
            this.getList();
        },
        handleCurrentChange(event) {
            this.searchForm.current = event;
            this.getList();
        },
        //审核
        toExamine(row, index, type) {
            this.tableData[index].visible = false;
            setAdopt({
                id: row.id,
                visibility: type == 1 ? 'hidden' : 'show'
            }).then(res => {
                this.$message({
                    message: '成功',
                    type: 'success'
                });
                this.getList()
            })
        },
        //置顶/取消置顶
        onTop(row, index) {
            setTop({
                id: row.id
            }).then(res => {
                this.$message({
                    message: '成功',
                    type: 'success'
                });
                this.getList()
            })
        },
        //显示内容
        hideDetail(row, index, type) {
            this.$confirm(type == 1 ? '此内容不会在医生主页的列表显示,以及不会被医生看到,是否隐藏?' : '显示内容后，此内容可以被其他用户和医生看到，是否显示？', '提示消息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                customClass: 'message-confirm-style'
            }).then(() => {
                setHidden({
                    id: row.id
                }).then(res => {
                    this.$message({
                        message: '成功',
                        type: 'success'
                    });
                    this.getList()
                })
            })
        },
        statusChange(e) {
            if (e == 'init') {
                this.searchForm.status = this.statusSelect;
                this.searchForm.visibility = null;
            } else if (e == 'show') {
                this.searchForm.visibility = this.statusSelect;
                this.searchForm.status = null;
            } else if (e == 'hidden') {
                this.searchForm.visibility = this.statusSelect;
                this.searchForm.status = null;
            }
        },
        //搜索条件下拉框
        selectChangeFunction(e) {
            this.searchForm = {
                current: 1,//页数
                size: 10,//每页多少条
                startTime: null,
                visibility: null,//状态
                endTime: null,
                status: null,//审核状态
                patientRealName: null,//真实姓名
                doctorName: null,//对应医生
                patientUsername: null,//用户名
                commentStars: null,//评价星级,
                seq: null,
            }
            this.inputvalue = null;
        },
        //选择时间
        timeChange(e) {
            this.searchForm.startTime = e[0] + ' ' + '00:00:00';
            this.searchForm.endTime = e[1] + ' ' + '23:59:59';
        },
    },
    //⽣命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getList()
    },
    //⽣命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    //beforeCreate() {}, //⽣命周期 - 创建之前
    //beforeMount() {}, //⽣命周期 - 挂载之前
    //beforeUpdate() {}, //⽣命周期 - 更新之前
    //updated() {}, //⽣命周期 - 更新之后
    //beforeDestroy() {}, //⽣命周期 - 销毁之前
    //destroyed() {}, //⽣命周期 - 销毁完成
    //activated() {}, //如果页⾯有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped lang="less">
@import './index.less';
</style>